import React from 'react';
import PropTypes from 'prop-types';

import PersonCard from 'components/cards/entities/PersonCard';
import SimilarEntities from 'components/sections/SimilarEntities';

import { PersonType } from 'propTypes/entities';

const SimilarPersons = ({ ariaLabel, entities, title, url }) => (
	<SimilarEntities
		ariaLabel={ariaLabel}
		Card={PersonCard}
		cardParams={{ typeWidth: 'fluidPortraitSlide' }}
		entities={entities}
		isPortraitCard
		title={title || 'Персоны'}
		url={url}
	/>
);

SimilarPersons.propTypes = {
	ariaLabel: PropTypes.string,
	entities: PropTypes.arrayOf(PersonType).isRequired,
	title: PropTypes.string,
	url: PropTypes.string
};

export default SimilarPersons;
